<ng-container *transloco="let t">
  @let newDesign = isNewDesignOn();
  <div
    class="intl-phone_input form-control-labelled"
    #wrapper>
    <button
      class="intl-phone_flag btn __clear __l control-button"
      [class.new-design]="newDesign"
      type="button"
      [appDropdown]="dropdown"
      [appDropdownOptions]="{ maxHeight: 187, width: wrapper.offsetWidth }"
      (shown)="dropdownOpened()"
      (hidden)="dropdownClosed()"
      ngPreserveWhitespaces>
      @if (country?.code) {
        <span
          class="flag"
          [ngClass]="country?.code?.toLowerCase()"></span>
      } @else {
        <span class="fa fa-flag-o"></span>
      }
      @if (!newDesign) {
        <app-icon
          name="triangle-arrow"
          [class.__up]="isDropdownOpened" />
      }
    </button>

    <input
      class="form-control __height-l"
      [class.new-design]="newDesign"
      id="intlPhone"
      type="tel"
      autocomplete="off"
      name="phone"
      appPhoneInput
      [formControl]="phoneControl"
      [class.ng-not-empty]="phoneControl.value.length"
      #phoneInput />
    <label
      class="form-control-labelled_label__no-star"
      [class.new-design]="newDesign"
      for="intlPhone"
      >{{ t('common.phone-number') }}</label
    >
  </div>

  <ng-template #dropdown>
    <ul class="intl-phone_countries">
      <li
        class="select-txbox"
        (click)="$event.stopPropagation()">
        <input
          class="form-control __s"
          [formControl]="searchControl"
          id="phoneInputSearch"
          [placeholder]="t('common.filter-placeholder')" />
      </li>
      @if ((highlightedCountries() | RegexPipe: 'name' : searchValue).length) {
        <li class="intl-phone_highlighted-countries">
          <ul class="list-unstyled">
            @for (item of highlightedCountries() | RegexPipe: 'name' : searchValue; track item) {
              <li>
                <a
                  class="intl-phone_country"
                  (click)="selectCountry($event, item)"
                  href="#">
                  <span class="intl-phone_country_flag">
                    <i
                      class="flag"
                      [ngClass]="item?.code.toLowerCase()"></i>
                  </span>
                  <b>{{ item.name }}</b>
                  +{{ item.phoneCode }}
                </a>
              </li>
            }
          </ul>
        </li>
      }

      <li>
        <ul class="list-unstyled">
          @for (item of notHighlightedCountries() | RegexPipe: 'name' : searchValue; track item) {
            <li>
              <a
                class="intl-phone_country"
                (click)="selectCountry($event, item)"
                href="#">
                <span class="intl-phone_country_flag">
                  <i
                    class="flag"
                    [ngClass]="item?.code.toLowerCase()"></i>
                </span>
                <b>{{ item.name }}</b>
                +{{ item.phoneCode }}
              </a>
            </li>
          }
        </ul>
      </li>

      @if ((allCountries | RegexPipe: 'name' : searchValue).length === 0) {
        <li class="select-list_null-option">
          {{ t('common.empty-search') }}
        </li>
      }
    </ul>
  </ng-template>
</ng-container>
